export default "__VITE_ASSET__B6P8TCgp__"